export const ANALYTICS_TOKEN = 'ANALYTICS_FEATURE_CONFIG';
